import { GET_ALL_CONFERENCIAS, GET_CONFERENCIA } from './mutation-types'

export default {
  [GET_ALL_CONFERENCIAS]: (state, conferencias) => {
    state.conferencias = conferencias
  },
  [GET_CONFERENCIA]: (state, conferencia) => {
    state.conferencia = conferencia
  },
}
